import React from "react";
import SGBSCategoryList from "../../features/SGBSCategoryList/SGBSCategoryList";
import "./SGBSCategory.scss";

const SGBSCategory = () => {
  return (
    <div>
      <SGBSCategoryList />
    </div>
  );
};

export default SGBSCategory;
